import type { Category } from "@/constants/categories";

type SweetsProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  sweets: "https://images.unsplash.com/photo-1481391319763-23fe2c955614?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): SweetsProduct => ({
  id,
  name,
  categorySlug: "sweets-chocolates",
  brand,
  unit,
  price,
  image: IMG.sweets,
});

export const SWEETS_CHOCOLATES_PRODUCTS: SweetsProduct[] = [
  // Cookies & biscuits
  item("sw-anand-namkeen-bhel", "Anand Namkeen Bhel Chaat Masala Cookies", "Anand", "200g", 4.99),
  item("sw-cappuccino-cookies", "Cappuccino Wafer Cookies", "VG Select", "150g", 3.99),
  item("sw-digestive-veg-crackers", "Digestive Veg Crackers", "McVitie's", "200g", 4.49),
  item("sw-right-angle-cashew", "Right Angle Cashew Chocolate Cookies", "Right Angle", "150g", 4.99),

  // Milk chocolate & bars
  item("sw-cadbury-dairy-milk", "Cadbury Dairy Milk", "Cadbury", "160g", 4.99),
  item("sw-cadbury-fruit-nut", "Cadbury Fruit & Nut", "Cadbury", "160g", 5.49),
  item("sw-kit-kat-family", "Kit Kat Family Pack", "Nestlé", "8 pack", 6.99),
  item("sw-toblerone-milk", "Toblerone Milk Chocolate", "Toblerone", "100g", 5.99),

  // Cream crackers & biscuit range
  item("sw-cream-crackers", "Cream Crackers", "Jacob's", "200g", 3.99),
  item("sw-butter-cookies-tin", "Butter Cookies Tin", "Danish", "454g", 9.99),
  item("sw-oatmeal-cookies", "Oatmeal Cookies", "VG Select", "200g", 4.49),
  item("sw-marie-gold", "Marie Gold Biscuit", "Britannia", "250g", 3.49),

  // Kkobuk Chip
  item("sw-kkobuk-choco", "Kkobuk Chip Choco", "Orion", "80g", 3.49),
  item("sw-kkobuk-corn", "Kkobuk Chip Corn", "Orion", "80g", 3.49),
  item("sw-kkobuk-injeolmi", "Kkobuk Chip Injeolmi", "Orion", "80g", 3.49),

  // 2-in-1 & mix packs
  item("sw-2in1-snack-mix", "2-in-1 Snack Mix", "VG Select", "200g", 5.49),
  item("sw-value-pack-biscuits", "Value Pack Biscuits", "Parle", "600g", 7.99),
  item("sw-tea-garden-biscuit", "Tea Garden Biscuit", "Unibic", "200g", 3.99),

  // Lay's & savoury sweets
  item("sw-lays-classic", "Lay's Classic", "Lay's", "150g", 3.99),
  item("sw-lays-sour-cream", "Lay's Sour Cream & Onion", "Lay's", "150g", 3.99),
  item("sw-ritz-crackers", "Ritz Crackers Original", "Ritz", "200g", 4.99),

  // Hershey's
  item("sw-hersheys-milk-choc", "Hershey's Milk Chocolate", "Hershey's", "100g", 4.49),
  item("sw-hersheys-cookies-cream", "Hershey's Cookies 'n' Creme", "Hershey's", "100g", 4.49),
  item("sw-hersheys-nuggets", "Hershey's Nuggets", "Hershey's", "200g", 8.99),
  item("sw-hersheys-syrup", "Hershey's Chocolate Syrup", "Hershey's", "680g", 7.99),

  // Hungry Jack / Pancakes
  item("sw-hungry-jack-pancake", "Hungry Jack Pancake Mix", "Hungry Jack", "907g", 6.99),
  item("sw-hungry-jack-syrup", "Hungry Jack Syrup", "Hungry Jack", "710ml", 7.49),

  // Misc sweets
  item("sw-choc-digestives", "Chocolate Digestives", "McVitie's", "300g", 4.99),
  item("sw-bourbon-cream", "Bourbon Cream Biscuit", "Britannia", "150g", 2.99),
  item("sw-choco-pie-lotte", "Choco Pie", "Lotte", "6 pcs", 5.49),
  item("sw-wafer-chocolate", "Chocolate Wafer", "Pirouline", "100g", 4.49),
  item("sw-jelly-cups", "Jelly Cups Assorted", "ABC", "6 pcs", 3.99),
  item("sw-marshmallow-bag", "Marshmallows", "Haribo", "200g", 3.99),
];
